import React from 'react';
import { Grid } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';
import { useHistory, useParams } from 'react-router-dom';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { useStyles } from './styles';

interface SubmitButtonProps {
  disabled: boolean;
  matches: boolean;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  disabled,
  matches
}: SubmitButtonProps) => {
  const { submitButtonSeciton } = useStyles();
  const { capaFriendsId } = useParams<{ capaFriendsId: string }>();
  const history = useHistory();

  return (
    <Grid className={submitButtonSeciton}>
      <div id="button-signup-complete">
        <CustomizedButton
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          disabled={disabled}
        >
          회원가입 완료
        </CustomizedButton>
      </div>
      {!capaFriendsId && matches && (
        <CustomizedButton
          variant="text"
          className="login-btn"
          size="large"
          type="button"
          color="default"
          endIcon={<ChevronRight />}
          onClick={() => {
            history.push('/login');
          }}
        >
          <CustomizedTypography variant="body1" color="textSecondary">
            바로 로그인하기
          </CustomizedTypography>
        </CustomizedButton>
      )}
    </Grid>
  );
};

export default SubmitButton;
